if (!customElements.get('ly-popover-v4')) {
    customElements.define('ly-popover-v4', class extends HTMLElement {

        connectedCallback() {
            this.input = this.querySelector('input.ly-popover-v4-checkbox')

            this.input.addEventListener('change', this.handleVisiblityChange)

            this.syncState(this.input.checked)
        }

        disconnectedCallback() {
            this.input.removeEventListener('change', this.handleVisiblityChange)
        }

        handleVisiblityChange = evt => {
            const visible = evt.target.checked

            this.syncState(visible)

            this.dispatchVisibilityChangeEvent(visible)
        }

        dispatchVisibilityChangeEvent = (visible) => {
            this.dispatchEvent(new CustomEvent('visibility_change', {
                detail: {
                    visible
                }
            }))

            window.publish('bus:popover_v4_visibility_changed', {
                visible,
                popover: this
            })
        }

        syncState = (visible) => {
            // 控制自身
            if (visible) {
                this.renderBody()
            }

            this.classList.toggle('is-open', visible)

            // 控制 root
            document.documentElement.classList.toggle('is-popover-v4-open', visible)

            const gorgias = document.querySelector('#gorgias-chat-container')
            if (gorgias) {
                gorgias.style.display = visible ? 'none' : 'block'
            }
        }

        renderBody = () => {
            const body = this.querySelector('.ly-popover-v4-inner-body')
            const template = body?.querySelector('template')

            if (!body || !template) return

            body.appendChild(template.content)
            template.remove()
        }

        get bodyContent() {
            const body = this.querySelector('.ly-popover-v4-inner-body')
            const template = body?.querySelector('template')

            return template?.content || body
        }

        open = () => {
            this.input.checked = true
            this.syncState(true)
            this.dispatchVisibilityChangeEvent(true)
        }

        close = () => {
            this.input.checked = false
            this.syncState(false)
            this.dispatchVisibilityChangeEvent(false)
        }
    })
}

